import type { UseFormRegisterReturn } from 'react-hook-form';

import { TextareaElement } from './styles';

type Props = {
	id?: string;
	registration: UseFormRegisterReturn;
	className?: string;
	placeholder?: string;
	rows?: number;
	maxLength?: number;
	disabled?: boolean;
	isError?: boolean;
};

export const Textarea = ({
	id,
	registration,
	className,
	placeholder,
	rows,
	maxLength,
	disabled,
	isError,
	...props
}: Props) => (
	<TextareaElement
		id={id}
		{...registration}
		className={className}
		placeholder={placeholder}
		rows={rows}
		maxLength={maxLength}
		disabled={disabled}
		isError={isError}
		{...props}
	/>
);
